import PropTypes from 'prop-types';

import styles from './AccordionList.module.scss';

const AccordionList = ({ children, customClassName = '', withSeparator = false }) => (
  <div data-test-id="accordion-list" className={`${customClassName} ${withSeparator ? styles['with-separator'] : ''}`}>
    {children}
  </div>
);

AccordionList.propTypes = {
  /**
   * Children must be Accordion components
   */
  children: PropTypes.oneOfType([
    PropTypes.node, PropTypes.arrayOf(PropTypes.node)
  ]).isRequired,
  customClassName: PropTypes.string,
  /**
   * Enable separator (border) between Accordion children
   */
  withSeparator: PropTypes.bool
};

export default AccordionList;
